<template>
  <t-content main>
    <c-tournament-header v-if="zoneId" :zone="zoneId" language="de" />
    <t-container class="error-view" :data-qe-id="`error-view-${code}`">
      <div class="flex-center">
        <t-text>
          <h1>{{ $t('errorView.main.title') }}</h1>
          <div v-html="errorText"></div>
          <img :src="require('@/assets/error/error_asset.png')" alt="broken cards" />
          <div class="flex-center">
            <t-button @click="onAction">{{ $t('errorView.main.button') }}</t-button>
          </div>
        </t-text>
      </div>
    </t-container>
  </t-content>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { marked } from 'marked'
import { ERROR_CODES } from '../model/ErrorCodes'
import CTournamentHeader from '@/components/CTournamentHeader.vue'
import { jslog } from '@gd/jslog'

const props = defineProps<{ code: string; zoneId: string }>()
const emit = defineEmits(['close'])
const { t } = useI18n()

const errorCodeAsString = computed(() => {
  return ERROR_CODES[parseInt(props.code)] || props.code
})

/**
 * provide error text with default
 */
const errorText = computed(() => {
  const text = t('errorView.codes.' + errorCodeAsString.value) as string
  // in development it will contain the key if no text has been found - live it's empty
  if (/errorView/.test(text) || !text) {
    return marked(t('errorView.codes.default'))
  }
  return marked(text)
})

/**
 * TODO: maybe the logic could be improved
 */
function onAction() {
  // reload tournaments
  if (
    props.zoneId &&
    // FORBIDDEN and NOT_FOUND is often the case when the user is not allowed to see the
    // zone ( maybe wrong/invalid/manipulated zone name or a none german user tries to enter the skatmaster zone). To
    // avoid navigations loops we redirect them to the zone selection page
    parseInt(props.code) !== ERROR_CODES.FORBIDDEN &&
    parseInt(props.code) !== ERROR_CODES.NOT_FOUND
  ) {
    location.href = location.pathname + '#/tournaments/' + props.zoneId
    // trigger reload - otherwise the page will not do this because of the anchor
    location.reload()
  } else {
    location.href = location.pathname
  }
  // this.$router.push('/')
}

// const error = this.$store.state.error
// tracks that the ErrorView is shown
jslog.send({ name: 'error-view', data: { code: props.code, zoneId: props.zoneId } })

// handle special logic:
switch (parseInt(props.code)) {
  case ERROR_CODES.UNAUTHORIZED:
    // theoretically we can send the user to the login page:
    // this.$router.replace('/extern/login')
    break
}
</script>

<style lang="less" scoped>
.flex-center {
  flex: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: stretch;
  justify-items: flex-start;
  align-items: center;
}

.error-view {
  max-width: 40em;
  padding-bottom: 4em;
}
img {
  display: block;
  margin: 2em auto;
}
</style>
